import { render, staticRenderFns } from "./AdminVehiclesForm.vue?vue&type=template&id=492f2d90&scoped=true"
import script from "./AdminVehiclesForm.vue?vue&type=script&lang=js"
export * from "./AdminVehiclesForm.vue?vue&type=script&lang=js"
import style0 from "./AdminVehiclesForm.vue?vue&type=style&index=0&id=492f2d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f2d90",
  null
  
)

export default component.exports